import { useEffect, useState } from 'react';
import InputMaskPlugin from 'inputmask';

const COUNTRY_PHONE_MASK = {
  ru: '+7 999 999 99 99',
};

const useInputMask = ({ id, onChange, value, lang = 'ru' }) => {
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    const input = document.getElementById(id);
    const im = new InputMaskPlugin(COUNTRY_PHONE_MASK[lang], { showMaskOnHover: false });
    im.mask(input);
  }, []);

  const handleFocus = (_e: FocusEvent) => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  const handleChange = ({ target }) => {
    onChange(target.name, target.value);
  }

  const hasValue = !!value || value === 0;

  return { hasValue, focused, handleBlur, handleFocus, onChange, handleChange };
};

export default useInputMask;
